import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as c from '../constant';
import * as actions from '../action';

function UpdateModal({
  createInput,
  updateFaq,
  formData,
  getFaqList,
  updateList,
  setFormData,
  showFaq,
  id,
  history,
  createRichTextEditor,
  htmlToDraft,
  draftToHtml,
  convertToRaw
}) {
  const setModal = useContext(ModalContext);

  const handleOnSubmit = e => {
    e.preventDefault();
    const payload = {
      ...formData,
      description_en: draftToHtml(convertToRaw(formData.description_en.getCurrentContent())),
      description_tl: draftToHtml(convertToRaw(formData.description_tl.getCurrentContent()))
    }
    updateFaq(id, payload, ({ data }) => {
      setModal({ isOpen: false });
      getFaqList();
      showFaq(id);
      history.push(`/general-settings/faq/main/${_.get(data, 'id')}`);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
        description_en: htmlToDraft(updateList.description_en),
        description_tl: htmlToDraft(updateList.description_tl)
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  const onChange = e => {
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  useEffect(() => {
    onSetFormData();
  }, {});

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createInput(
              { key: 'title_en', label: 'Title English:' },
              { required: true, minLength: 3 }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'title_tl', label: 'Title Filipino:' },
              { required: true, minLength: 3 }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'sequence', label: 'Sequence:' },
              { required: true, minLength: 3, type: 'number' }
            )}
          </div>
          <div className="col-12 form-group">
            {createRichTextEditor(
              { key: 'description_en', label: 'Description English:' },
              { minLength: 3, required: true }
            )}
          </div>
          <div className="col-12 form-group">
            {createRichTextEditor(
              { key: 'description_tl', label: 'Description Filipino:' },
              { minLength: 3, required: true }
            )}
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label">
              Is Active: &nbsp;
            </label>
            <input
              name="is_active"
              type="checkbox"
              checked={_.get(formData, 'is_active')}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button type="submit" className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3">
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  updateFaq: PropTypes.instanceOf(Function).isRequired,
  getFaqList: PropTypes.instanceOf(Function).isRequired,
  showFaq: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  createRichTextEditor: PropTypes.instanceOf(Function).isRequired,
  htmlToDraft: PropTypes.instanceOf(Function).isRequired,
  draftToHtml: PropTypes.instanceOf(Function).isRequired,
  convertToRaw: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
